// Hari K:22-02-2023 :BT-119138:Funds View- available banks modal-start

import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BzHeading, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import { handleModal } from "../../redux/actions/modals";




const BankAvailableModal = () => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    
    const availableBankList = useSelector(state => state.funds.availableBankList);

    const handleClose = () => {
        dispatch(handleModal([{ "BANK_AVAILABLE_MODAL": false }]));
    };

    return (

        <BzModal className='modal-breeze' show={modals['BANK_AVAILABLE_MODAL']} onHide={handleClose} centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={10} className='d-flex justify-content-start align-self-center'>
                            <BzHeading className='font-medium font-size4 color-text'>Available Banks</BzHeading>
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 d-flex align-items-center'>
                        <Col>
                            {availableBankList?.map((each) => (
                                <div className="font-regular font-size2 color-text py-1">{each?.sBankName}</div>
                            ))}
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter className='bdr-none'>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0'>
                        <Col>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    )
}

export default memo(BankAvailableModal)

// Hari K:22-02-2023 :BT-119138:Funds View- available banks modal-end